export const apiRoot = "https://api.nonought.io/dev";